import { render } from "./SendToKitchenModal.vue?vue&type=template&id=5a2fc428"
import script from "./SendToKitchenModal.vue?vue&type=script&lang=js"
export * from "./SendToKitchenModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__